import { cn } from "@/utils/cn";
import type { ReactNode } from "react";

type BackofficeNavTextProps = {
  /** Menu aberto: o texto aparece. Recolhido, ele se recolhe junto, suavemente. */
  visible: boolean;
  /** Parte da direita da linha (chevron, selo, bolinha): fica colada à borda. */
  trailing?: boolean;
  /** Texto longo quebra em mais de uma linha, em vez de ser cortado com reticências. */
  wrap?: boolean;
  className?: string;
  children: ReactNode;
};

/**
 * O texto de um item do menu. Ao recolher o menu ele **não some de uma vez**:
 * a largura, a opacidade e o espaço até o ícone transitam juntos (o `overflow`
 * corta o que ainda não coube), no mesmo ritmo da largura do menu. O ícone
 * nunca se mexe — o item mantém o mesmo `padding` nos dois estados.
 */
export const BackofficeNavText = ({
  visible,
  trailing = false,
  wrap = false,
  className,
  children,
}: BackofficeNavTextProps) => (
  <span
    aria-hidden={visible ? undefined : true}
    className={cn(
      "min-w-0 overflow-hidden",
      wrap && !trailing ? "whitespace-normal" : "whitespace-nowrap",
      "transition-[max-width,opacity,margin] duration-300 ease-out motion-reduce:transition-none",
      trailing
        ? "shrink-0"
        : cn("flex-1 text-left", wrap ? "leading-tight" : "truncate"),
      visible
        ? trailing
          ? "ml-2 max-w-24 opacity-100"
          : "ml-3 max-w-64 opacity-100"
        : "ml-0 max-w-0 opacity-0",
      className
    )}
  >
    {children}
  </span>
);
